import { ToEntity } from 'core/common/mappers';
import { LegacyOrderData, Order, OrderData, OrderQuiz } from '../entities';
import { OrderDto } from '../services/dto';

export class OrderDtoMapper implements ToEntity<Order, OrderDto> {
  toEntity(dto: OrderDto): Order {
    return {
      orderId: dto.id,
    };
  }
}

export class OrderQuizDtoMapper implements ToEntity<OrderQuiz, OrderDto> {
  toEntity(dto: OrderDto): OrderQuiz {
    return {
      orderId: dto.id,
      userId: dto.user_id,
      nebulaId: Number(dto.user_id),
      offerName: dto.offer_id,
      funnel: dto.funnel,
      domain: dto.domain,
      source: dto.source,
      orderData: this.normalizeOrderData(dto.extra_data),
      error: dto.error,
    };
  }

  private normalizeOrderData(extraData: OrderData | LegacyOrderData): OrderData {
    if (this.isLegacyOrderData(extraData)) {
      return {
        ...extraData,
        subjects: extraData.order_data.subjects,
        reports: [],
        scan: extraData.quiz_data.scan ?? { photoId: '' },
      };
    }

    return {
      ...extraData,
      reports: Array.isArray(extraData.reports) ? extraData.reports : [],
      scan: extraData.scan ?? { photoId: '' },
    };
  }

  private isLegacyOrderData(data: OrderData | LegacyOrderData): data is LegacyOrderData {
    return 'order_data' in data;
  }
}
